import { render } from "./LearnerUploads.vue?vue&type=template&id=f8c8ff7a"
import script from "./LearnerUploads.vue?vue&type=script&lang=js"
export * from "./LearnerUploads.vue?vue&type=script&lang=js"

import "./LearnerUploads.vue?vue&type=style&index=0&id=f8c8ff7a&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__